/**
 * localStorage-backed layout mode persistence (FR-013).
 *
 * Safe against storage being unavailable (private mode, disabled cookies,
 * garbage values). Mirrors the pattern in lib/displayName.ts.
 */
const KEY = 'webrtc:layoutMode'

export type LayoutMode = 'grid' | 'spotlight'

export function readLayoutMode(): LayoutMode {
  try {
    const stored = localStorage.getItem(KEY)
    if (stored === 'grid' || stored === 'spotlight') return stored
    return 'grid'
  } catch {
    return 'grid'
  }
}

export function writeLayoutMode(mode: LayoutMode): void {
  try {
    localStorage.setItem(KEY, mode)
  } catch {
    // ignore — best effort
  }
}
